import styled from 'styled-components';

export const SignupNameSection = styled.div`
    padding: calc(100vh*(51/812)) calc(100vw*(36/375)) calc(100vh*(60/812)) calc(100vw*(30/375));
    height: 100%;
    overflow-y: scroll;
`;

export const NameBlock = styled.div`
    margin-top: calc(100vh * (52 / 812));
`;

export const TitleWrapper = styled.div``
export const TitleTxt = styled.h3`
    font-weight: 700;
    font-size: calc(100vw * (20 / 375));
    line-height: calc(100vw * (29 / 375));
`;
export const TitleNote = styled.div`
    font-weight: 500;
    font-size: calc(100vw * (14 / 375));
    line-height: calc(100vw * (20 / 375));
    color: #7F7F7F;
`;
export const InputElementDescription = styled.div`
    font-weight: 700;
    font-size: calc(100vw * (20 / 375));
    line-height: calc(100vw * (29 / 375));
`;


export const NameInputBlock = styled.div`
    position: relative;
    margin-top: calc(100vw * (35 / 375));
`;

export const InputStyle = styled.input`
    border: 1px solid #D5D5D5;
    border-radius: calc(100vw * (5 / 375));
    width: 100%;
    padding: calc(100vw * (11 / 375));
    &:focus {
        border: 1px solid #FFCF19;
    }
    &::placeholder {
        font-size: calc(100vw * (14 / 375));
        color: #C6C6C6;
    }
    &.error_active {
        border 1px solid #de0000;
    }
`;

export const DeleteButton = styled.button`
    position: absolute;
    top: 50%;
    right: 5%;
    height: calc(100vw * (18 / 375));
    transform: translate(0, -50%);
`;

export const DeleteIcon = styled.img`
    width: calc(100vw * (18 / 375));
`;

export const ErrorBlock = styled.div`
    margin-top: calc(100vw * (4 / 375));
`;

export const ErrorIcon = styled.img`
    width: calc(100vw * (12 / 375));
    margin-right: calc(100vw * (4.5 / 375));
`;

export const ErrorMessage = styled.p`
    display: inline-block;
    font-size: calc(100vw * (10 / 375));
    color: #de0000;
    
`;